import { validAttributeNumberValue } from './validationCore'
import { AttributeValidationNumberArray, AttributeValueRange, AttributeValidationError } from './validationTypes'

export const validateNumberArray = (arr: number[], range: AttributeValueRange, start?: number, end?: number): AttributeValidationNumberArray => {
  const firstIdx: number = start ?? 0
  const limitIdx: number = end ?? arr.length
  const res: AttributeValidationNumberArray = {
    isValid: false,
    error: AttributeValidationError.INVALID_MEMBERS,
    invalidIndexes: [],
  }

  for (let idx = firstIdx; idx < limitIdx; idx++) {
    const validation = validAttributeNumberValue(arr[idx], range)
    if (validation.error) {
      res.invalidIndexes.push(idx)
    }
  }

  if (res.invalidIndexes?.length === 0) {
    res.isValid = true
    res.error = null
  }

  return res
}
